import { render, staticRenderFns } from "./ApprovePermission.vue?vue&type=template&id=5fb48655&scoped=true&"
import script from "./ApprovePermission.vue?vue&type=script&lang=js&"
export * from "./ApprovePermission.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePermission.vue?vue&type=style&index=0&id=5fb48655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb48655",
  null
  
)

export default component.exports